/* « Trouvez votre coque » : pilote l'option « Modèle iPhone » du thème (snippet wstch-trouver-coque). */
(function () {
  'use strict';

  // Mesure : chaque canal est protégé séparément, un échec de mesure ne bloque jamais le choix.
  function emit(name, payload) {
    try { if (typeof window.gtag === 'function') window.gtag('event', name, payload); } catch (e) {}
    try { if (Array.isArray(window.dataLayer)) window.dataLayer.push(Object.assign({ event: name }, payload)); } catch (e) {}
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, payload);
      }
    } catch (e) {}
  }

  var RE_MAGSAFE = /\(?\s*compatible\s*mag\s*safe\s*\)?/i;
  var CASSE = { pro: 'Pro', max: 'Max', plus: 'Plus', air: 'Air', mini: 'mini' };

  // « iPhone 17 PRO MAX (compatible Magsafe) » -> { cle: 'iphone 17 pro max', libelle: 'iPhone 17 Pro Max', magsafe: true }
  function analyser(valeur) {
    var brut = String(valeur || '').trim();
    if (!/^iphone\b/i.test(brut)) return null;
    var magsafe = /mag\s*safe/i.test(brut);
    var base = brut.replace(RE_MAGSAFE, ' ').replace(/[\s(\/,-]+$/, '').replace(/\s+/g, ' ').trim();
    var mots = base.split(' ').slice(1).map(function (m) {
      var bas = m.toLowerCase();
      if (CASSE[bas]) return CASSE[bas];
      return /^\d+e$/i.test(m) ? m.slice(0, -1) + 'e' : m;
    });
    var libelle = ['iPhone'].concat(mots).join(' ');
    return { cle: libelle.toLowerCase(), libelle: libelle, magsafe: magsafe };
  }

  function init(racine) {
    var donnees;
    try { donnees = JSON.parse(racine.querySelector('[data-wtc-donnees]').textContent); } catch (e) { return; }
    var form = racine.closest('form') || document.querySelector('form[action*="/cart/add"]');
    var champId = form && form.querySelector('select[name="id"], input[name="id"]');
    var select = racine.querySelector('[data-wtc-modele]');
    var blocMagsafe = racine.querySelector('[data-wtc-magsafe]');
    var resultat = racine.querySelector('[data-wtc-resultat]');
    if (!select || !champId) return;

    // Modèles dans l'ordre de la fiche ; une même clé peut porter plusieurs écritures (casse, parenthèses).
    var modeles = [];
    var parCle = {};
    donnees.valeurs.forEach(function (valeur) {
      var m = analyser(valeur);
      if (!m) return;
      if (!parCle[m.cle]) { parCle[m.cle] = { libelle: m.libelle, oui: [], non: [] }; modeles.push(m.cle); }
      parCle[m.cle][m.magsafe ? 'oui' : 'non'].push(valeur);
    });
    if (modeles.length < 2) return;

    modeles.forEach(function (cle) {
      var o = document.createElement('option');
      o.value = cle;
      o.textContent = parCle[cle].libelle;
      select.appendChild(o);
    });

    function variantesPour(valeur) {
      return donnees.variantes.filter(function (v) { return v.options[donnees.index] === valeur; });
    }

    // Parmi les écritures possibles, on garde celle qui a au moins une variante disponible.
    function meilleureValeur(liste) {
      for (var i = 0; i < liste.length; i++) {
        if (variantesPour(liste[i]).some(function (v) { return v.dispo; })) return liste[i];
      }
      return liste[0];
    }

    function variantePour(valeur) {
      var courante = donnees.variantes.filter(function (v) { return String(v.id) === String(champId.value); })[0];
      var candidates = variantesPour(valeur);
      var memesOptions = courante && candidates.filter(function (v) {
        return v.options.every(function (opt, i) { return i === donnees.index || opt === courante.options[i]; });
      })[0];
      return memesOptions || candidates.filter(function (v) { return v.dispo; })[0] || candidates[0];
    }

    function appliquer(valeur, cle, version) {
      var cible = variantePour(valeur);
      if (!cible) return;
      var option = document.querySelector('.t4s-swatch__option[data-id="' + donnees.index + '"]');
      var pastille = option && Array.prototype.filter.call(option.querySelectorAll('[data-swatch-item]'), function (el) {
        return el.getAttribute('data-value') === valeur;
      })[0];
      if (pastille) {
        pastille.click();
      } else {
        // Repli si la structure du thème change : la page se recharge sur la variante choisie.
        var url = new URL(window.location.href);
        url.searchParams.set('variant', cible.id);
        window.location.assign(url.toString());
        return;
      }
      var texte = 'Sélectionné : ' + parCle[cle].libelle + (version ? ', ' + version : '') + '.';
      var choisie = variantePour(valeur);
      var dispo = choisie && choisie.dispo;
      resultat.textContent = dispo ? texte : texte + ' Cette version est épuisée dans cette finition : essayez une autre finition ci-dessous.';
      resultat.classList.toggle('is--alerte', !dispo);
      emit('ws_coque_modele', { modele: parCle[cle].libelle, magsafe: version === 'version compatible MagSafe', disponible: !!dispo });
    }

    function radios() { return blocMagsafe.querySelectorAll('input[type="radio"]'); }

    select.addEventListener('change', function () {
      var cle = select.value;
      Array.prototype.forEach.call(radios(), function (r) { r.checked = false; });
      resultat.textContent = '';
      if (!cle) { blocMagsafe.hidden = true; return; }
      var m = parCle[cle];
      if (m.oui.length && m.non.length) {
        blocMagsafe.hidden = false;
        return;
      }
      blocMagsafe.hidden = true;
      var seule = m.oui.length ? m.oui : m.non;
      appliquer(meilleureValeur(seule), cle, m.oui.length ? 'version compatible MagSafe' : '');
    });

    blocMagsafe.addEventListener('change', function (e) {
      if (!e.target.matches('input[type="radio"]') || !select.value) return;
      var m = parCle[select.value];
      var oui = e.target.value === 'oui';
      appliquer(meilleureValeur(oui ? m.oui : m.non), select.value, oui ? 'version compatible MagSafe' : 'version standard');
    });

    // État initial : le sélecteur affiche la variante déjà présélectionnée par le thème (ce que contiendrait le panier).
    var initiale = donnees.variantes.filter(function (v) { return String(v.id) === String(champId.value); })[0];
    var mInit = initiale && analyser(initiale.options[donnees.index]);
    if (mInit && parCle[mInit.cle]) {
      select.value = mInit.cle;
      if (parCle[mInit.cle].oui.length && parCle[mInit.cle].non.length) {
        blocMagsafe.hidden = false;
        blocMagsafe.querySelector('input[value="' + (mInit.magsafe ? 'oui' : 'non') + '"]').checked = true;
      }
    }

    // La liste native du modèle fait doublon : on la masque, elle reste le repli sans JavaScript et le sélecteur la pilote.
    var natif = document.querySelector('.t4s-swatch__option[data-id="' + donnees.index + '"]');
    if (natif) natif.style.display = 'none';

    racine.hidden = false;
  }

  function demarrer() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-wtc]'), function (racine) {
      if (racine.dataset.wtcPret) return;
      racine.dataset.wtcPret = '1';
      init(racine);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer); else demarrer();
})();
